import React, { Component } from "react";

import {
  Box,
  Icon,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TableSortLabel,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import Scrollbars from "react-custom-scrollbars";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { userService } from "_services/user.service";
import { PATIENT_LIST, TASK_STATUS_OBJ } from "__helpers/constants";
import PatientTasks from "../SinglePatientDetail/PatientTasks";
import PreviewSurvey from "../PatientDashboard/PreviewSurvey";

import tasksImg from "assets/img/icons/tasksImg.png";
import taskAdd from "assets/img/icons/plus.svg";
import eye from "assets/img/eye.png";
import layout from "assets/img/layout.png";

import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import logoMrj from "assets/img/asglogo.png";
import enMsg from "__helpers/locale/en/en";
import CloseIcon from "@material-ui/icons/Close";
import PreviewSubmittedSurvey from "../SinglePatientDetail/PreviewSubmittedSurvey";
import ContactDialog from "../SinglePatientDetail/ContactDialog";

const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};

class TasksList extends Component {
  constructor(props) {
    super(props);
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));
    console.log("userinfo---details", userinfo);
    this.dateUtility = new DateFnsUtils();
    this.state = {
      tasks: "",
      loading: false,
      patientName: "",
      patientId: "",
      patientTaskId: "",
      openTaskModal: false,
      openTemplates: false,
      openPatientTask: false,
      dischargePlannerId: userinfo.dischargePlanner.id,
      facilityId: userinfo.dischargePlanner.facility.facilityId,
      apiPartner: "",
      templates: [],
      sortBy: "taskName",
      sortAsc: true,
      selectedTemplateId: "",
      selectedTemplateTasks: [],
      selectedTemplateIds: [],
      showPreview: false,
      selectedTaskId: null,
      pendingSaveTemplates: null,
      printTaskList: [],
      patientDetail: this.props.patientDetail ? this.props.patientDetail : {},
      patientTaskGroup: this.props.patientTaskGroup
        ? this.props.patientTaskGroup
        : [],
      multiPatientMode: this.props.multiPatientMode
        ? this.props.multiPatientMode
        : false,
    };
    this.statusDescriptions = {
      4: { description: "Incomplete", color: "#0D81B4" },
      5: { description: "Issue", color: "#FF0000 " },
      6: { description: "Complete", color: "#01A7A6" },
    };
    this.handleOpenTemplates = this.handleOpenTemplates.bind(this);
    this.openTaskModal = this.openTaskModal.bind(this);
    this.updatePatientModalClose = this.updatePatientModalClose.bind(this);
    this.loaderStatus = this.loaderStatus.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let tasks = nextProps.tasks;
    let patientName = nextProps.patientName;
    let patientId = nextProps.patientId;
    let loading = nextProps.loading;
    let multiPatientMode = nextProps.multiPatientMode;
    this.setState({
      tasks: tasks,
      loading: loading,
      patientName: patientName,
      patientId: patientId,
      multiPatientMode: multiPatientMode,
      patientDetail: nextProps.patientDetail ? nextProps.patientDetail : {},
      patientTaskGroup: nextProps.patientTaskGroup
        ? nextProps.patientTaskGroup
        : [],
      templatesValue: nextProps.templatesValue ? nextProps.templatesValue : [],
    });
  }

  updatePatientModalClose = () => {
    let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));
    this.setState({
      patientModalStatus: false,
      openTaskModal: false,
      patientItemList: patientList,
    });
  };

  openTaskModal(taskId) {
    this.setState({
      openTaskModal: true,
      patientTaskId: taskId,
    });
  }

  loaderStatus = (status) => {
    this.setState({
      loading: status,
    });
  };
  handleClose = () => {
    this.setState({ showPreview: false, selectedTaskId: null });
  };
  handleEyeClick = (taskId) => {
    this.setState({ showPreview: true, selectedTaskId: taskId });
  };
  async handleOpenTemplates() {
    this.setState({ openTemplates: true });
    let selectedTemplateIds = this.state.selectedTemplateIds;
    selectedTemplateIds.splice(0, selectedTemplateIds.length);
    let showNotification = {};
    const apiUrl =
      apiPath.getTaskTemplateByDPAll + "?facilityId=" + this.state.facilityId;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        if (response.status === 400) {
          showNotification = {
            title: "Template",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.status === 401) {
          userService.logout();
          //window.location.reload(true);
        } else {
          showNotification = {
            title: "Template",
            message: "Bad response from server",
            type: "danger",
          };
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetch Templates Data", data);

      this.setState({
        templates: data,
      });
    } catch (error) {
      console.error("Error fetching template tasks:", error);
      showNotification = {
        title: "Task Template",
        message: "Error fetching template tasks",
        type: "danger",
      };
    }

    userService.showNotification(showNotification);
  }

  handleCloseTemplates = () => {
    this.setState({ openTemplates: false });
    this.setState({ openPatientTask: false });
  };

  handleTemplateSelect = (templateId) => {
    const name = templateId;
    let value = templateId;

    let selectedTemplateIds = this.state.selectedTemplateIds;
    if (!selectedTemplateIds.includes(name)) {
      selectedTemplateIds.push(name);
    } else {
      const index = selectedTemplateIds.indexOf(name);
      if (index > -1) {
        selectedTemplateIds.splice(index, 1);
      }
    }
    this.setState({
      selectedTemplateIds: selectedTemplateIds,
    });
  };

  async fetchContactListAndValidate() {
    const { patientId, dischargePlannerId } = this.state;
    if (!patientId) return false; // safety check

    const apiUrl = `${apiPath.GetAllPatientContactList}?patientId=${patientId}&dpId=${dischargePlannerId}`;

    let showNotification = {};
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = {
          title: "Contact List",
          message: "Bad Request",
          type: "danger",
        };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = {
          title: "Contact List",
          message: "Error fetching data",
          type: "danger",
        };
      }

      const rawData = await response.json();
      // Filter out contacts that PCC stopped returning. They stay visible in
      // the dedicated contact dialog (with a "Removed from PCC" badge) but
      // must not appear as task/survey recipients.
      const data = Array.isArray(rawData)
        ? rawData.filter((c) => !c.removedFromPcc)
        : rawData;
      this.setState({ contactList: data });

      if (showNotification.title)
        userService.showNotification(showNotification);

      // 🔹 Validation rules
      if (!data || data.length === 0) return false;

      const hasPrimary = data.some(
        (c) => c.isPrimary === true || c.primary === true
      );
      if (!hasPrimary) {
        userService.showNotification({
          title: "Contact List",
          message:
            "Please mark at least one contact as Primary before saving templates.",
          type: "warning",
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error fetching contact list", error);
      userService.showNotification({
        title: "Contact List",
        message: "Server Error",
        type: "danger",
      });
      return false;
    }
  }

  // 🔹 Handle save with validation
  handleSaveTemplates = async () => {
    const {
      patientId,
      facilityId,
      dischargePlannerId,
      selectedTemplateIds,
      templates,
    } = this.state;

    if (!selectedTemplateIds || selectedTemplateIds.length === 0) return;

    console.log("Selected template IDs:", selectedTemplateIds);

    const templatesWithSurvey = [];
    const templatesWithoutSurvey = [];

    // Fetch tasks for each template and check survey logic
    for (const templateId of selectedTemplateIds) {
      try {
        const response = await fetch(
          apiPath.TaskTemplatesBulkEdit + "/" + templateId,
          {
            method: "GET",
            headers: generalAuthTokenHeader(),
          }
        );

        if (!response.ok)
          throw new Error("Failed to fetch tasks for templateId " + templateId);

        const tasks = await response.json();

        const hasSurveyTask = tasks.some((t) => t.hasSurvey && t.surveyFormId);
        const template = templates.find((t) => t.id === templateId);
        if (!template) continue;

        if (hasSurveyTask) {
          templatesWithSurvey.push(template);
        } else {
          templatesWithoutSurvey.push(template);
        }
      } catch (error) {
        console.error(
          "Error fetching tasks for templateId:",
          templateId,
          error
        );
      }
    }

    console.log(
      "Templates without survey:",
      templatesWithoutSurvey.map((t) => t.id)
    );
    console.log("Templates with survey:", templatesWithSurvey.map((t) => t.id));

    // 🔹 If any template has a survey → hold everything until contact validation
    if (templatesWithSurvey.length > 0) {
      const contactsOk = await this.fetchContactListAndValidate();

      if (!contactsOk) {
        // Hold all templates (both survey and non-survey)
        this.setState({
          openContactDialog: true,
          openTemplates: false,
          pendingSaveTemplates: {
            patientId,
            facilityId,
            dischargePlannerId,
            selectedTemplateIds: selectedTemplateIds, // hold all
            templates,
          },
        });
        console.warn(
          "At least one template has a survey and no primary contact exists. All templates are pending."
        );
        return;
      }

      // Contacts exist → save everything
      await this.saveTemplates({
        patientId,
        facilityId,
        dischargePlannerId,
        selectedTemplateIds: selectedTemplateIds,
        templates,
      });

      return;
    }

    // 🔹 If none have survey → save immediately
    await this.saveTemplates({
      patientId,
      facilityId,
      dischargePlannerId,
      selectedTemplateIds: selectedTemplateIds,
      templates,
    });

    console.log("handleSaveTemplates finished.");
  };

  // 🔹 Extracted save logic
  saveTemplates = async ({
    patientId,
    facilityId,
    dischargePlannerId,
    selectedTemplateIds,
    templates,
  }) => {
    this.setState({ openTemplates: false });

    const payload = selectedTemplateIds.map((templateId) => {
      const template = templates.find((t) => t.id === templateId);
      return {
        patientId,
        templateId,
        templateName: template.templateName,
        dischargePlannerId,
        facilityId,
      };
    });

    try {
      const response = await fetch(apiPath.PatientTaskBulk, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      let showNotification = {};
      if (response.status === 201) {
        const data = await response.json();
        console.log("Save Templates Response", data);
        showNotification = {
          title: "Save Tasks",
          message: "Task Added successfully",
          type: "success",
        };
        this.props.updatePatient();
      } else {
        showNotification = {
          title: "Save Tasks",
          message: "Error saving Tasks",
          type: "danger",
        };
      }

      userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error during fetch:", error);
      userService.showNotification({
        title: "Save Tasks",
        message: "Error saving Tasks",
        type: "danger",
      });
    }
  };

  // 🔹 Called after a contact is successfully added
  handleContactAdded = async () => {
    const { pendingSaveTemplates } = this.state;

    if (pendingSaveTemplates) {
      const contactsOk = await this.fetchContactListAndValidate();

      if (contactsOk) {
        await this.saveTemplates(pendingSaveTemplates);
        this.setState({ pendingSaveTemplates: null, openContactDialog: false });
      } else {
        // Still no primary → keep dialog open or notify user
        this.setState({ openContactDialog: false });
      }
    }
  };

  handlePrint = async (patientId) => {
    let selectedTemplateIds = this.state.selectedTemplateIds;
    selectedTemplateIds.splice(0, selectedTemplateIds.length);
    try {
      // Fetch patient tasks specific to the current patient (this.state.patientId)
      let apiUrl = apiPath.getPatientList + "/" + this.state.patientId;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to fetch patient tasks. Status: ${response.status}`
        );
      }
      const data = await response.json();
      this.setState({
        printTaskList: data[0].patientTask,
        printTaskListGroup: data,
        openPatientTask: true, // Open dialog after fetching tasks
      });
    } catch (error) {
      console.error("Error fetching patient tasks:", error);
    }
  };

  async handleDownloadPDF() {
    console.log("Print button clicked");
    console.log("Selected Template IDs:", this.state.selectedTemplateIds);
    let showNotification = {};
    try {
      if (this.state.selectedTemplateIds.length === 0) {
        showNotification = {
          title: "Error",
          message: "No templates selected",
          type: "danger",
        };
        userService.showNotification(showNotification);
        return;
      }
      const formattedTemplateIds = this.state.selectedTemplateIds.map(
        (id) => `${id}`
      );
      const apiUrl = `${apiPath.getPdfDownload}/${this.state.patientId}`;
      console.log("API URL:", apiUrl);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formattedTemplateIds),
      });

      if (response.status === 400) {
        showNotification = {
          title: enMsg.sessionExpireTitle,
          message: enMsg.sessionExpire,
          type: "warning",
        };
        this.setState({ loading: false });
        return;
      } else if (response.status === 401 || !response.ok) {
        showNotification = {
          title: enMsg.connectionFailed,
          message: enMsg.networkFailedError,
          type: "danger",
        };
        this.setState({ loading: false });
        return;
      }
      const blob = await response.blob();
      console.log("Blob size:", blob.size);
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      showNotification = {
        title: "Preview PDF",
        message: "Preview successful, please check the new tab",
        type: "success",
      };
      this.setState({ openPatientTask: false });
      this.setState({ loading: false });
    } catch (error) {
      console.error("Download PDF error:", error);
      showNotification = {
        title: enMsg.connectionFailed,
        message: enMsg.networkFailedError,
        type: "danger",
      };
      this.setState({ loading: false });
    }
    userService.showNotification(showNotification);
  }
  handleSort = (sortBy) => {
    console.log("clicked");

    const { printTaskListGroup, sortAsc } = this.state;

    // Toggle sorting order
    const newSortAsc = this.state.sortBy === sortBy ? !sortAsc : true;

    const sortedList = printTaskListGroup.sort((a, b) => {
      const valueA = a[sortBy];
      const valueB = b[sortBy];

      // Check for undefined values
      if (valueA === undefined || valueB === undefined) return 0;

      // String comparison for taskName
      if (
        sortBy === "taskName" &&
        typeof valueA === "string" &&
        typeof valueB === "string"
      ) {
        const upperValueA = valueA.toUpperCase();
        const upperValueB = valueB.toUpperCase();
        if (upperValueA < upperValueB) return newSortAsc ? -1 : 1;
        if (upperValueA > upperValueB) return newSortAsc ? 1 : -1;
        return 0;
      }

      // Default comparison for other fields
      if (valueA < valueB) return newSortAsc ? -1 : 1;
      if (valueA > valueB) return newSortAsc ? 1 : -1;
      return 0;
    });

    this.setState({
      printTaskListGroup: sortedList,
      sortBy,
      sortAsc: newSortAsc,
    });
  };

  render() {
    const {
      task,
      sortBy,
      sortAsc,
      patientTaskGroup,
      selectedTemplateIds,
      printTaskList,
      printTaskListGroup,
      patientId,
      multiPatientMode,
      patientName,
      openPatientTask,
      openTemplates,
      templates,
      showPreview,
      selectedTaskId,
    } = this.state;
    console.log("printTaskList:", printTaskListGroup);
    console.log("patientIdpatientIdpatientId:", patientId);

    const filteredTasks = (() => {
      const validTemplates = [];
      const noTemplates = [];

      Object.keys(patientTaskGroup).forEach((templateName) => {
        if (templateName !== "null" && templateName !== "No Template") {
          validTemplates.push(templateName);
        } else {
          noTemplates.push(templateName);
        }
      });

      return { validTemplates, noTemplates };
    })();

    return (
      <div id="facility-index">
        {this.state.openContactDialog && (
          <ContactDialog
            open={this.state.openContactDialog}
            onClose={this.handleContactAdded}
            contactList={this.state.contactList}
            patientId={this.state.patientId}
            onUpdate={() => this.fetchContactListAndValidate()}
          />
        )}
        {patientId && patientId !== "" && !multiPatientMode ? (
          <PatientTasks
            openTaskModal={this.state.openTaskModal}
            updatePatientModalClose={this.updatePatientModalClose}
            patientDetail={this.state.patientDetail}
            updatePatient={this.props.updatePatient}
            loaderStatus={this.loaderStatus}
            patientTaskId={this.state.patientTaskId}
          />
        ) : (
          ""
        )}
        <div>
          {patientId && patientId !== "" && !multiPatientMode ? (
            <Box
              width={1}
              className="right-box-content categorylist-cover tasks add-border"
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 180px)",
              }}
            >
              <div className="box-header tsks-h">
                <span className="TasksTitle">Tasks</span>
                {/* <span className="patientName selectedtask-name"> */}
                {/* &nbsp; - {this.state.patientName} */}
                {/* </span> */}
                <span
                  onClick={this.handlePrint}
                  className="pointer"
                  style={{
                    position: "absolute",
                    right: "3.5rem",
                    top: "6px",
                    color: "white",
                    padding: "2px",

                    width: "1em",
                    height: "1em",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                >
                  <PrintOutlinedIcon style={{ fontSize: "1.2rem" }} />
                </span>

                <img
                  src={layout}
                  alt=""
                  className="pointer"
                  onClick={this.handleOpenTemplates}
                  style={{
                    position: "absolute",
                    right: "25px",
                    top: "10px",
                    width: "15px",
                    height: "15px",
                    zIndex: 1,
                  }}
                />

                <img
                  src={taskAdd}
                  alt=""
                  className="pointer task-add"
                  onClick={(e) => this.openTaskModal("")}
                  disabled={this.state.loading}
                />
              </div>

              <Box
                justifyContent="center"
                className="middle-section"
                style={{
                  overflowY: "hidden",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <div
                  className="middle-section-content"
                  style={{ flex: 1, display: "flex", flexDirection: "column" }}
                >
                  <Scrollbars
                    autoHide={true}
                    universal={true}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    className="TaskListScroll"
                  >
                    {patientTaskGroup &&
                    typeof patientTaskGroup === "object" &&
                    Object.values(patientTaskGroup).some(
                      (taskList) =>
                        Array.isArray(taskList) && taskList.length > 0
                    ) ? (
                      (() => {
                        const validTemplates = [];
                        const noTemplates = [];

                        Object.keys(patientTaskGroup).forEach(
                          (templateName) => {
                            if (
                              templateName !== "null" &&
                              templateName !== "No Template"
                            ) {
                              validTemplates.push(templateName);
                            } else {
                              noTemplates.push(templateName);
                            }
                          }
                        );

                        return (
                          <>
                            {noTemplates.map((templateName) => (
                              <div key={templateName}>
                                <span style={{ fontWeight: "bold" }}></span>
                                {Array.isArray(
                                  patientTaskGroup[templateName]
                                ) &&
                                  patientTaskGroup[templateName].map((task) => (
                                    <Box
                                      className={`task-name-list task-name ${
                                        TASK_STATUS_OBJ[task.changeStatus]
                                      }`}
                                      key={task.id}
                                    >
                                      <span
                                        className="pointer"
                                        onClick={() =>
                                          this.openTaskModal(task.id)
                                        }
                                      >
                                        {task.taskName || "Unknown"}
                                      </span>
                                      <span>
                                        {task.dueDate ? task.dueDateString : ""}
                                        {task.hasSurvey ? (
                                          <img
                                            src={eye}
                                            alt=""
                                            style={{
                                              width: "14px",
                                              height: "14px",
                                              verticalAlign: "middle",
                                              marginTop: "3px",
                                              marginLeft: "5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.setState({
                                                showPreview: true,
                                                selectedTaskId: task.id,
                                              })
                                            }
                                          />
                                        ) : (
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "14px",
                                              height: "14px",
                                              marginTop: "3px",
                                              marginLeft: "5px",
                                            }}
                                          ></span>
                                        )}
                                      </span>
                                    </Box>
                                  ))}
                              </div>
                            ))}

                            {validTemplates.map((templateName) => (
                              <div key={templateName}>
                                <span style={{ fontWeight: "bold" }}>
                                  {templateName}
                                </span>
                                {Array.isArray(
                                  patientTaskGroup[templateName]
                                ) &&
                                  patientTaskGroup[templateName].map((task) => (
                                    <Box
                                      className={`task-name-list task-name ${
                                        TASK_STATUS_OBJ[task.changeStatus]
                                      }`}
                                      key={task.id}
                                    >
                                      <span
                                        className="pointer"
                                        onClick={() =>
                                          this.openTaskModal(task.id)
                                        }
                                      >
                                        {task.taskName || "Unknown"}
                                      </span>
                                      <span>
                                        {task.dueDateString || ""}
                                        {task.hasSurvey ? (
                                          <img
                                            src={eye}
                                            alt=""
                                            style={{
                                              width: "14px",
                                              height: "14px",
                                              verticalAlign: "middle",
                                              marginTop: "3px",
                                              marginLeft: "5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.setState({
                                                showPreview: true,
                                                selectedTaskId: task.id,
                                              })
                                            }
                                          />
                                        ) : (
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "14px",
                                              height: "14px",
                                              marginTop: "3px",
                                              marginLeft: "5px",
                                            }}
                                          ></span>
                                        )}
                                      </span>
                                    </Box>
                                  ))}
                              </div>
                            ))}
                          </>
                        );
                      })()
                    ) : (
                      <div className="task-name-list task-name">No Tasks!</div>
                    )}
                  </Scrollbars>
                </div>
              </Box>
            </Box>
          ) : (
            <Box width={1} className="right-box-content tasks">
              <div className="box-header tsks-h">Tasks</div>
              <div>
                {this.state.loading ? <LinearProgress color="primary" /> : ""}
              </div>
              <Box
                display="flex"
                justifyContent="center"
                className="middle-section"
              >
                <div className="middle-section-content middle-section-content-middle">
                  <img src={tasksImg} alt="" height={90} width={100} className="text" />
                  {multiPatientMode ? (
                    <div className="text">
                      Select single patient to view tasks
                    </div>
                  ) : (
                    <div className="text">
                      Please select patient to view task list
                    </div>
                  )}
                </div>
              </Box>
            </Box>
          )}
        </div>
        <Dialog
          open={openPatientTask}
          onClose={this.handleCloseTemplates}
          aria-labelledby="form-dialog-title"
          maxWidth="xl"
          PaperProps={{
            style: {
              maxHeight: "90vh",
            },
          }}
        >
          <DialogTitle id="form-dialog-title">
            Print {patientName} Tasks
            {/* {sortBy === "taskName" && (
    <TableSortLabel
      active={true}
      direction={sortAsc ? "asc" : "desc"}
      onClick={() => this.handleSort('taskName')}
    />
  )} */}
          </DialogTitle>

          <DialogContent>
            {filteredTasks.noTemplates.length > 0 ||
            filteredTasks.validTemplates.length > 0 ? (
              <>
                {filteredTasks.noTemplates.map((templateName) => (
                  <div key={templateName}>
                    <span style={{ fontWeight: "bold" }}></span>
                    {Array.isArray(patientTaskGroup[templateName]) &&
                      patientTaskGroup[templateName].map((task) => (
                        <Box
                          key={task.id}
                          width={1}
                          className="categorylist-cover"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedTemplateIds.includes(
                                    task.id
                                  )}
                                  color="primary"
                                  onClick={() =>
                                    this.handleTemplateSelect(task.id)
                                  }
                                />
                              }
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {task.taskName || "No Task Available"} -{" "}
                                  </div>
                                  <span
                                    style={{
                                      color: this.statusDescriptions[
                                        task.changeStatus
                                      ]?.color,
                                      fontWeight: "bold",
                                      marginLeft: 8,
                                    }}
                                  >
                                    {this.statusDescriptions[task.changeStatus]
                                      ?.description || "No Status Available"}
                                  </span>
                                </div>
                              }
                            />
                          </Box>
                          <div
                            style={{
                              marginTop: 8,
                              marginBottom: 15,
                              wordBreak: "break-word",
                            }}
                          >
                            {task.taskDescription ? (
                              <>
                                {task.taskDescription.length > 50
                                  ? `${task.taskDescription.substring(0, 50)}`
                                  : task.taskDescription}
                                {task.taskDescription.length > 100 && (
                                  <>
                                    <br />
                                    {task.taskDescription.substring(50, 100)}
                                    {task.taskDescription.length > 100 && "..."}
                                  </>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </Box>
                      ))}
                  </div>
                ))}
                {filteredTasks.validTemplates.map((templateName) => (
                  <div key={templateName}>
                    <span style={{ fontWeight: "bold" }}></span>
                    {Array.isArray(patientTaskGroup[templateName]) &&
                      patientTaskGroup[templateName].map((task) => (
                        <Box
                          key={task.id}
                          width={1}
                          className="categorylist-cover"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedTemplateIds.includes(
                                    task.id
                                  )}
                                  color="primary"
                                  onClick={() =>
                                    this.handleTemplateSelect(task.id)
                                  }
                                />
                              }
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {task.taskName || "No Task Available"} -{" "}
                                  </div>
                                  <span
                                    style={{
                                      color: this.statusDescriptions[
                                        task.changeStatus
                                      ]?.color,
                                      fontWeight: "bold",
                                      marginLeft: 8,
                                    }}
                                  >
                                    {this.statusDescriptions[task.changeStatus]
                                      ?.description || "No Status Available"}
                                  </span>
                                </div>
                              }
                            />
                          </Box>
                          <div
                            style={{
                              marginTop: 8,
                              marginBottom: 15,
                              wordBreak: "break-word",
                            }}
                          >
                            {task.taskDescription ? (
                              <>
                                {task.taskDescription.length > 50
                                  ? `${task.taskDescription.substring(0, 50)}`
                                  : task.taskDescription}
                                {task.taskDescription.length > 100 && (
                                  <>
                                    <br />
                                    {task.taskDescription.substring(50, 100)}
                                    {task.taskDescription.length > 100 && "..."}
                                  </>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </Box>
                      ))}
                  </div>
                ))}
              </>
            ) : (
              "No tasks available"
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseTemplates} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDownloadPDF} color="primary">
              Print
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openTemplates}
          onClose={this.handleCloseTemplates}
          aria-labelledby="form-dialog-title"
          maxWidth="xl"
          PaperProps={{
            style: {
              maxHeight: "90vh", // Adjust as needed
            },
          }}
        >
          <DialogTitle id="form-dialog-title">Select Template</DialogTitle>
          <DialogContent>
            {templates.length > 0 ? (
              templates
                .sort((a, b) => (a.templateName > b.templateName ? 1 : -1))
                .map((template) => (
                  <Box width={1} className="categorylist-cover">
                    <FormControlLabel
                      key={template.id}
                      control={
                        <Checkbox
                          checked={
                            this.state.selectedTemplateIds.includes(template.id)
                              ? true
                              : false
                          }
                          color="primary"
                          onClick={() => this.handleTemplateSelect(template.id)}
                        />
                      }
                      label={template.templateName}
                    />
                  </Box>
                ))
            ) : (
              <div>No templates available</div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseTemplates} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveTemplates} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {showPreview && (
          <Dialog
            open={showPreview}
            onClose={this.handleClose}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>
              Preview Survey
              <IconButton
                aria-label="close"
                onClick={this.handleClose}
                style={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {/* Render only when taskId is available */}
              {selectedTaskId && <PreviewSurvey taskId={selectedTaskId} />}
              {/* <PreviewSubmittedSurvey
              key={selectedTaskId}
                taskId={selectedTaskId}
                //survey={selectedSurvey}
              /> */}
            </DialogContent>
          </Dialog>
        )}{" "}
      </div>
    );
  }
}

export default TasksList;
